import type { AnalyticsTranslation } from "./en.analytics";

const analyticsUz: AnalyticsTranslation = {
  analytics: {
    nav: "Analitika",
    title: "Analitika",
    orgTitle: "Analitika — barcha loyihalar",
    orgIntro: "Siz ko‘ra oladigan barcha loyihalar bo‘yicha sinov va prod xatolari.",
    projectIntro: "Ushbu loyihada sinov qanday ketyapti va prodga nimalar o‘tib ketyapti.",
    loading: "Analitika yuklanmoqda…",
    refreshing: "Yangilanmoqda…",
    period: {
      label: "Davr",
      p30d: "30 kun",
      p90d: "90 kun",
      p6m: "6 oy",
      p12m: "12 oy",
      custom: "Boshqa",
      from: "Dan",
      to: "Gacha",
      apply: "Qo‘llash",
      range: "{{from}} – {{to}}",
      invalid: "Boshlanish sanasi tugash sanasidan oldin bo‘lishi kerak.",
    },
    export: {
      bugs: "Xatolarni CSV ga eksport",
      tasks: "Vazifalarni CSV ga eksport",
    },
    units: { d: " kun", h: " soat", m: " daq" },
    insights: {
      title: "Xulosalar",
      none: "Bu davrda hozircha alohida ko‘zga tashlanadigan narsa yo‘q. Xulosalar yakunlangan raundlar va tahlil qilingan xatolar paydo bo‘lganda chiqadi.",
      good: "Yaxshi",
      warning: "E’tibor bering",
      bad: "Choralar kerak",
      fpyUp: "Birinchi urinishda o‘tish {{value}} gacha oshdi (oldingi davrda {{previous}} edi).",
      fpyDown: "Birinchi urinishda o‘tish {{value}} gacha tushdi (oldingi davrda {{previous}} edi).",
      fpySame: "Birinchi urinishda o‘tish barqaror: {{value}}.",
      fpyOnly: "Birinchi urinishda o‘tish: {{value}}.",
      testingGap: "Tahlil qilingan xatolarning {{value}} qismini ({{n}}) sinov aniqlashi kerak edi.",
      testingGapWhere: "Tahlil qilingan xatolarning {{value}} qismini ({{n}}) sinov aniqlashi kerak edi — asosan {{label}} da.",
      topRootCause: "Asosiy sabab: {{label}} (toifalangan xatolarning {{value}} qismi).",
      slowMitigationBad: "{{label}} xatolari bartaraf etish muddatiga atigi {{value}} hollarda ulgurdi.",
      slowMitigationGood: "{{label}} xatolari bartaraf etish muddatiga {{value}} hollarda ulgurdi.",
      overdueActions: "Muddati o‘tgan vazifalar: {{n}}.",
      recurring: "Yopilgandan keyin qaytgan xatolar: {{n}} (takrorlanish darajasi {{value}}).",
      hotspot: "Eng ko‘p xatolar «{{label}}» tegli holatlarda ({{n}}).",
    },
    testing: {
      title: "Sinov",
      tasksTested: "Sinalgan vazifalar",
      roundsFinished: "Yakunlangan raundlar: {{n}}",
      firstPassYield: "Birinchi urinishda o‘tish",
      fpyHint: "Xatosiz 1-raund · birinchi raundlar: {{n}}",
      avgRounds: "O‘tish uchun raundlar",
      avgRoundsHint: "O‘rtacha · 3 va undan ko‘p: {{n}}",
      medianToPass: "O‘tish vaqti",
      medianHint: "Mediana, sinovga tayyor → o‘tdi",
      findings: "Topilmalar",
      findingsHint: "Yozilgan holatlardan tashqari topilgan muammolar",
      monthly: "Oylar bo‘yicha raundlar va xatolar",
      rounds: "Raundlar",
      failures: "Xato natijalar",
      fpyMonthly: "Oylar bo‘yicha birinchi urinishda o‘tish",
      byTag: "Teglar bo‘yicha xatolar",
      bySection: "Bo‘limlar bo‘yicha xatolar",
      noFailures: "Bu davrda xato natijalar yo‘q.",
      slowest: "Eng sekin o‘tganlar",
      slowestEmpty: "Bu davrda hech bir vazifa o‘tmadi.",
      task: "Vazifa",
      time: "Vaqt",
      roundsCol: "Raundlar",
      testers: "Testerlar",
      tester: "Tester",
      results: "Natijalar",
      problems: "Topilgan muammolar",
      testersEmpty: "Bu davrda natijalar yozilmagan.",
      empty: "Bu davrda sinov bo‘lmagan",
      emptyBody: "Testerlar raundlarni yakunlagach, bu yerda birinchi urinishda o‘tish, raundlar soni, muammoli joylar va eng sekin vazifalar ko‘rinadi.",
    },
    bugs: {
      title: "Prod xatolari",
      total: "Xabar qilingan xatolar",
      openNow: "Hozir ochiq",
      recurrence: "Takrorlanish darajasi",
      recurrenceHint: "Qaytgan xatolar: {{n}}",
      actions: "Vazifalar",
      actionsValue: "{{open}} ochiq · {{overdue}} muddati o‘tgan",
      onTime: "O‘z vaqtida bajarilgan",
      onTimeHint: "Davr ichida bajarilgan: {{n}}",
      monthly: "Oylar va jiddiylik bo‘yicha xatolar",
      bySeverity: "Jiddiylik bo‘yicha",
      rootCauses: "Asosiy sabablar",
      escapePoints: "Qaysi bosqichda aniqlanishi kerak edi",
      escapeHint: "Ajratilganlar: ikkita sinov bosqichi.",
      gap: "Sinovdagi bo‘shliq",
      gapIntro: "Sinov aniqlashi kerak bo‘lgan xatolar.",
      gapShare: "bosqichi ko‘rsatilgan xatolardan",
      gapMissing: "Hech qaysi test holati qamramagan",
      gapMissed: "Holat bor edi, lekin sinovda o‘tkazib yuborilgan",
      gapByComponent: "Komponentlar bo‘yicha",
      gapNone: "Bu davrda hech bir xato sinovga bog‘lanmadi.",
      timings: "Jiddiylik bo‘yicha javob vaqti",
      severity: "Jiddiylik",
      count: "Xatolar",
      ack: "Qabul qilish",
      mitigate: "Bartaraf etish",
      fix: "Tuzatish",
      target: "Maqsad",
      withinTarget: "Muddatida",
      noTarget: "Maqsad yo‘q",
      seenByVersion: "Versiyalar bo‘yicha xatolar",
      seenByVersionHint: "Har bir xato versiyaga bir martadan, shu davrda ko‘rilgan vaqti bo‘yicha sanaladi.",
      firstSeenByVersion: "Xatolar birinchi ko‘rilgan versiyalar",
      firstSeenByVersionHint: "Xato ilovada birinchi marta ko‘rilgan versiya, agar bu shu davrda bo‘lgan bo‘lsa.",
      byComponent: "Komponentlar bo‘yicha",
      none: "Bu davrda yo‘q.",
      unknown: "Ko‘rsatilmagan",
      empty: "Bu davrda prod xatolari yo‘q",
      emptyBody: "Xatolar xabar qilinganda, bu yerda ularni jiddiylik va oylar bo‘yicha, sabablari, qayerdan o‘tib ketgani va qanchalik tez hal qilingani ko‘rinadi.",
    },
    projects: {
      title: "Loyihalar",
      project: "Loyiha",
      tasksTested: "Sinalgan vazifalar",
      fpy: "Birinchi urinishda o‘tish",
      bugs: "Xatolar",
      open: "Ochiq",
      major: "S1 + S2",
      gap: "Sinovdagi bo‘shliq",
      overdue: "Muddati o‘tgan vazifalar",
      sortBy: "{{column}} bo‘yicha saralash",
      empty: "Siz hali hech qaysi loyiha a’zosi emassiz.",
    },
  },
};

export default analyticsUz;
